import { darkTheme, lightTheme, Theme } from '@rainbow-me/rainbowkit';
import _ from 'lodash';

export const yodlLightTheme = _.merge(lightTheme({}), {
  colors: {
    accentColor: '#4612b4',
    modalBackground: '#f8f5ff',
  },
} as Theme);

export const yodlDarkTheme = _.merge(darkTheme({}), {
  colors: {
    accentColor: '#4612b4',
    modalBackground: '#1a1a1a',
  },
} as Theme);
